import React from 'react';
import { useActor } from '@xstate/react';

import { useGlobalAppState } from '@order/GlobalAppState';

import type { OverlayEvent } from './Overlays.machine';

export const useOverlaysMachine = (): UseOverlayMachine => {
  const { overlayMachineRef } = useGlobalAppState();
  const [state, send] = useActor(overlayMachineRef);
  const { overlayId } = state.context;
  const sendOverlayEvent = React.useCallback(
    (event: OverlayEvent) => {
      send({ type: 'OVERLAY', ...event });
    },
    [send],
  );

  return {
    overlayId,
    sendOverlayEvent,
  };
};

type UseOverlayMachine = {
  readonly overlayId: string;
  readonly sendOverlayEvent: (event: OverlayEvent) => void;
};
